// Funciones
import { ROUTES } from '../../../../../const/routes';

/**
 * Assets del fondo del BlackJack
 * @param {*} scene
 */
export function cargaAssetsFondo(scene) {
  scene.load.image(
    'fondo',
    ROUTES.rutaBlackJackFondo + '/fondo4Resized.png'
    //ROUTES.rutaBlackJackFondo + '/fondo2disposicion.png'
  );
}
